// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KsJO","input":"styles_input__1p0UM"};